import { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { apiService } from '../services/api';
import Loader from '../components/Loader';

export default function ServiceDetail() {
  const { id } = useParams<{ id: string }>();
  const [service, setService] = useState<any>(null);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    loadService();
  }, [id]);

  const loadService = async () => {
    if (!id) return;
    try {
      const response = await apiService.getService(id);
      setService(response.data.data);
    } catch (error) {
      console.error('Error loading service:', error);
    } finally {
      setIsLoading(false);
    }
  };

  if (isLoading) {
    return <Loader className="py-12" />;
  }

  if (!service) {
    return (
      <div className="text-center py-8">
        <p className="text-tg-theme-hint">Услуга не найдена</p>
      </div>
    );
  }

  return (
    <div className="space-y-4">
      <h1 className="text-xl font-bold">{service.title}</h1>
      
      <div className="card">
        <p className="whitespace-pre-wrap">{service.description}</p>
      </div>

      <div className="card">
        <div className="flex items-center gap-3">
          <div className="w-12 h-12 rounded-full bg-tg-theme-button flex items-center justify-center text-white text-xl">
            {service.user.firstName[0]}
          </div>
          <div>
            <p className="font-semibold">{service.user.firstName}</p>
            <p className="text-sm text-tg-theme-hint">
              ⭐️ {service.user.rating.toFixed(1)}
            </p>
          </div>
        </div>
      </div>

      <button className="btn-primary w-full">
        💬 Написать исполнителю
      </button>
    </div>
  );
}
